export class ParticipantsEnrollmentRoutes {

	public static readonly ParticipantRecord = '/participant-record';

	public static readonly WhoWillEnroll = '/who-will-enroll';

	public static readonly BenefitEnrollment = '/benefit-enrollment';

	public static readonly Coverage = '/coverage';

	public static readonly Retirement = '/retirement-plans';

	public static readonly Review = '/review';

	public static readonly ExistingParticipantRecord = '/existing-participant-record';
}